module.exports = __webpack_public_path__ + "images/logo7a613ec4f5429ab266b168464c4e087f.svg";